import CreateWorkByFormLayout from '@Scenes/WorkScenes/CreateWorkByFormLayout'
import EditFormSceneWrapper from '@Scenes/WorkScenes/EditFormSceneWrapper'
import WorkDetailsStep from '@Scenes/WorkScenes/Steps/WorkDetailsStep'
import WritersStep from '@Scenes/WorkScenes/Steps/WritersSteps/WritersStep'
import WritersSharesRoleStep from '@Scenes/WorkScenes/Steps/WritersSteps/WritersSharesRolesStep'
import PublishersStep from '@Scenes/WorkScenes/Steps/PublishersSteps/PublishersStep'
import PublishersShareStep from '@Scenes/WorkScenes/Steps/PublishersSteps/PublishersShareStep'
import PublishersRelationsStep from '@Scenes/WorkScenes/Steps/PublishersSteps/PublishersRelationsStep'
import RecordingsStep from '@Scenes/WorkScenes/Steps/RecordingsStep'
import SubmissionStep from '@Scenes/WorkScenes/Steps/SubmissionStep'
import React from 'react'
import { FORM_ROUTE, STEP_ROUTES } from '@App/navigation/route'

const createCreateWorkByFormRoutes = () => ({
    path: FORM_ROUTE,
    element: <CreateWorkByFormLayout />,
    children: [
        {
            path: '',
            element: <EditFormSceneWrapper workType="create-form" />,
        },
        {
            path: STEP_ROUTES.workDetails,
            element: <WorkDetailsStep />,
        },
        {
            path: STEP_ROUTES.writers,
            element: <WritersStep />,
        },
        {
            path: STEP_ROUTES.writersShares,
            element: <WritersSharesRoleStep />,
        },
        {
            path: STEP_ROUTES.publishers,
            element: <PublishersStep />,
        },
        {
            path: STEP_ROUTES.publishersShares,
            element: <PublishersShareStep />,
        },
        {
            path: STEP_ROUTES.publishersWriters,
            element: <PublishersRelationsStep />,
        },
        {
            path: STEP_ROUTES.recordings,
            element: <RecordingsStep />,
        },
        {
            path: STEP_ROUTES.submission,
            element: <SubmissionStep />,
        },
    ],
})

export default createCreateWorkByFormRoutes
